import { render, staticRenderFns } from "./OpportunityModals.vue?vue&type=template&id=0ab6f4c0&scoped=true&"
import script from "./OpportunityModals.vue?vue&type=script&lang=js&"
export * from "./OpportunityModals.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityModals.vue?vue&type=style&index=0&id=0ab6f4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab6f4c0",
  null
  
)

export default component.exports